module.exports = __webpack_public_path__ + "img/website.1cd7a4e2.svg";